module.exports = ".add-newguest-wrapper{position:relative;top:-24px}\n"